import "./src/tokens.light.scss";
import "./src/tokens.dark.scss";
import "./src/core.scss";
import "./src/styles.scss";

export const shouldUpdateScroll = () => false;
